/**
 * api.js — fetch wrapper con JWT + manejo de errores centralizado.
 */
// Ver la nota de `utils.js`: `window.X`, no `const X`.
window.API = (() => {
  const BASE = '/api';

  function getToken() {
    return localStorage.getItem('token') || '';
  }

  function headers(extra = {}) {
    const h = { 'Content-Type': 'application/json', ...extra };
    const t = getToken();
    if (t) h['Authorization'] = `Bearer ${t}`;
    return h;
  }

  async function request(method, path, body = null, opts = {}) {
    const url = path.startsWith('/api') ? path : `${BASE}${path}`;
    const config = {
      method,
      headers: opts.formData ? { Authorization: `Bearer ${getToken()}` } : headers(),
    };
    if (body && !opts.formData) config.body = JSON.stringify(body);
    if (body && opts.formData) config.body = body;  // FormData

    try {
      const res = await fetch(url, config);
      if (res.status === 401) {
        // Token expirado — limpiar y redirigir al login
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.APP && window.APP.showLogin();
        return null;
      }
      if (!res.ok) {
        let msg = `Error ${res.status}`;
        // Se traga a propósito: esto solo INTENTA mejorar el mensaje leyendo el
        // `detail` del cuerpo. Si el cuerpo no es JSON —un 502 del proxy, una
        // página de error de nginx— el `Error ${status}` de arriba sigue siendo
        // cierto. No se pierde ningún fallo: ya hay uno en curso y es el que se
        // lanza dos líneas más abajo.
        try { const e = await res.json(); msg = e.detail || msg; } catch {}
        // El código viaja con el error. Sin esto, quien lo captura solo tiene un
        // texto y no puede distinguir un 403 —donde reintentar no arregla nada—
        // de un 503, que es justo lo que separa las tres salidas de
        // `Utils.errorState()`. Un fallo de red deja `status` sin definir.
        const err = new Error(msg);
        err.status = res.status;
        throw err;
      }
      if (res.status === 204) return null;
      return await res.json();
    } catch (err) {
      if (err.message && !err.message.startsWith('Error')) throw err;
      throw err;
    }
  }

  return {
    get:    (path, params = {}) => {
      const qs = Object.keys(params).length
        ? '?' + new URLSearchParams(params).toString() : '';
      return request('GET', path + qs);
    },
    post:   (path, body)        => request('POST',   path, body),
    put:    (path, body)        => request('PUT',    path, body),
    delete: (path)              => request('DELETE', path),
    upload: (path, formData)    => request('POST',   path, formData, { formData: true }),
  };
})();
